import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from './ui/card';
import { UtensilsCrossed, Heart, Trees, Coffee } from 'lucide-react';

const GrupFaaliyetSection = () => {
  const { t } = useLanguage();

  const companies = [
    {
      key: 'karYemek',
      icon: <UtensilsCrossed className="w-10 h-10" />,
      color: 'from-amber-500 to-amber-600',
      bgColor: 'bg-amber-50',
    },
    {
      key: 'kardelen',
      icon: <Heart className="w-10 h-10" />,
      color: 'from-rose-500 to-rose-600',
      bgColor: 'bg-rose-50',
    },
    {
      key: 'laVita',
      icon: <Trees className="w-10 h-10" />,
      color: 'from-emerald-500 to-emerald-600',
      bgColor: 'bg-emerald-50',
    },
    {
      key: 'coffeeBreak',
      icon: <Coffee className="w-10 h-10" />,
      color: 'from-amber-700 to-amber-800',
      bgColor: 'bg-amber-50',
    },
  ];

  return (
    <section id="grup" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t('groupCompanies.title')}
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto"></div>
        </div>

        {/* Companies Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {companies.map((company) => (
            <Card
              key={company.key}
              className="border-none shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 overflow-hidden group"
            >
              {/* Image Area */}
              <div className={`h-48 ${company.bgColor} relative overflow-hidden`}>
                <img
                  src={`/grup-${company.key}.jpg`}
                  alt={t(`groupCompanies.${company.key}`)}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.classList.add('flex', 'items-center', 'justify-center');
                    e.target.parentElement.innerHTML = `
                      <div class="flex flex-col items-center text-gray-400 group-hover:text-gray-500 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                          <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/>
                          <circle cx="9" cy="9" r="2"/>
                          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
                        </svg>
                        <span class="text-sm mt-2">Görsel Ekle</span>
                      </div>
                    `;
                  }}
                />
                {/* Gradient Overlay */}
                <div className={`absolute inset-0 bg-gradient-to-t ${company.color} opacity-0 group-hover:opacity-20 transition-opacity`}></div>
              </div>

              <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-4">
                  <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${company.color} flex items-center justify-center text-white shadow-lg`}>
                    {company.icon}
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">
                    {t(`groupCompanies.${company.key}`)}
                  </h3>
                </div>
                {/* Description placeholder */}
                <div className="h-16 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-sm">
                  Açıklama eklenecek...
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GrupFaaliyetSection;
